import styled from 'styled-components';

const MessageRow = styled.div`
  width: 100%;
  ${({isReply}) => (isReply ? 'padding-left: 60px;' : 'padding-right: 60px;')};
  display: flex;
  justify-content: ${({isReply}) => (isReply ? 'flex-end' : 'flex-start')};
`;

export default MessageRow;
